import { TICKER_SYMBOLS } from "../lib/constants";
import { TrendingUp, TrendingDown } from "lucide-react";

function TickerRow() {
    return (
        <>
            {TICKER_SYMBOLS.map((t, i) => (
                <span
                    key={i}
                    data-testid={`ticker-item-${t.symbol.replace(/[^a-zA-Z0-9]/g, "")}`}
                    className="group inline-flex items-center gap-2.5 px-5 font-mono text-[11px]"
                >
                    <span className="text-dim tracking-wide">{t.symbol}</span>
                    <span className="text-foreground font-medium tabular-nums">{t.value}</span>
                    <span
                        className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-medium tabular-nums ${
                            t.up ? "bg-pos/[0.12] text-pos" : "bg-neg/[0.10] text-neg"
                        }`}
                    >
                        {t.up ? <TrendingUp size={10} /> : <TrendingDown size={10} />}
                        {t.change}
                    </span>
                </span>
            ))}
        </>
    );
}

// A quiet dateline strip across the very top of the sheet.
export function StockTicker() {
    return (
        <div
            className="relative h-11 flex items-center overflow-hidden border-b border-line bg-surface-sunken"
            data-testid="stock-ticker"
        >
            <span className="hidden sm:inline-flex items-center gap-2.5 h-full pl-5 pr-6 shrink-0 border-r border-line bg-canvas">
                <span className="w-1.5 h-1.5 rounded-full bg-accent animate-pulse-dot" />
                <span className="eyebrow text-accent">Markets</span>
            </span>
            <div className="relative flex-1 overflow-hidden">
                <div className="ticker-track">
                    <TickerRow />
                    <TickerRow />
                </div>
                {/* Edge fades so items dissolve into the paper rather than clip */}
                <div className="pointer-events-none absolute inset-y-0 left-0 w-12 bg-gradient-to-r from-surface-sunken to-transparent" />
                <div className="pointer-events-none absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-surface-sunken to-transparent" />
            </div>
        </div>
    );
}
